<template>
  <div style="min-height: 750px;">
    <b-row style="margin: 3px;">
      <b-col sm="12" lg="6">
        <strong>
              {{ p_userShopBundleProductClientID ? '' : StoreLangTranslation.data['new_data'][StoreLang] }}
        </strong>
        <template v-if="d_loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
      </b-col>
      <b-col sm="12" lg="6" style="text-align: right;">
        <template v-if="!d_loading">
          <template v-if="d_saveLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-button variant="outline-success" @click="f_userShopBundleProductRecord()">
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </template>
        </template>
      </b-col>
    </b-row>

    <b-row v-if="!d_loading && d_userShopBundleProductWdm" style="overflow-x: hidden; overflow-y: auto; height: 650px;">
      <b-col sm="12" lg="12">

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row>
            <b-col sm="12" lg="8">
              <h3>
                <i class="fa fa-calculator"></i>
                {{ StoreLangTranslation.data['product_general_settings'][StoreLang] }}
                ( <small v-if="d_userShopBundleProductLayerId && d_userShopBundleProductId"> {{ 'L' + d_userShopBundleProductLayerId + '_' + d_userShopBundleProductId }} </small> )
              </h3>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.status">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['0'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.product_code[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea rows="1" class="form-control" v-model="d_userShopBundleProductData.pro_name[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea rows="3" class="form-control" v-model="d_userShopBundleProductData.pro_info[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.product_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['36'].options" :value="op.value">
                [{{ op.value }}] {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>


        <template v-if="['4', '5', '6', '7', '8', '9'].indexOf(d_userShopBundleProductData.product_type) !== -1">
          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="8">
                <h3>
                  <i class="fa fa-calculator"></i>
                  {{ StoreLangTranslation.data['wanalyzer_product_settings'][StoreLang] }}
                </h3>
              </b-col>
              <b-col sm="12" lg="4" style="text-align: right;"></b-col>
            </b-row>
          </b-card-header>
          <template v-if="['4', '5', '6', '7', '9'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <input type="text" class="form-control" v-model="d_userShopBundleProductData.wanalyzer_project_id[lang.label]">
              </b-col>
            </b-row>
            <hr>
          </template>
          <template v-if="['9'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['59']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleProductData.getting_analysis_output_with_column_inputs_id_type">
                  <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['59'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
          </template>
          <template v-if="['4'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <input type="text" class="form-control" v-model="d_userShopBundleProductData.wanalyzer_stats_id[lang.label]">
              </b-col>
            </b-row>
            <hr>
          </template>
          <template v-if="['7'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <input type="text" class="form-control" v-model="d_userShopBundleProductData.wanalyzer_machinelearning_id[lang.label]">
              </b-col>
            </b-row>
            <hr>
          </template>


          <!-- veri db sorgulama modeli -->
          <template v-if="['8'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <!-- Katman seçimleri ve sunucu seçimleri yapılma alanı -->
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['41']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <input type="text" class="form-control" v-model="d_userShopBundleProductData.layer_tree[lang.label]">
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleProductData.layer_usage_type">
                  <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['42'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <template v-if="d_userShopBundleProductData.layer_usage_type === '1'">
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="6">
                </b-col>
                <b-col sm="12" lg="6" style="text-align: right;">
                  <b-button variant="outline-secondary" @click="f_addNewSelectedLayersItem()">
                    <i class="fa fa-plus-circle"></i> {{ StoreLangTranslation.data['new_layer'][StoreLang] }}
                  </b-button>
                </b-col>
              </b-row>
              <template v-if="d_userShopBundleProductData.selected_layers.length > 0">
                <b-row v-for="(selected_layers_item, selected_layers_item_index) in d_userShopBundleProductData.selected_layers" :style="f_calculateItemStyle(selected_layers_item_index)">
                  <b-col sm="12" lg="12">
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="10">
                        <strong>{{ selected_layers_item_index + 1 }} )</strong>
                      </b-col>
                      <b-col sm="12" lg="2">
                        <b-button variant="outline-danger" @click="f_deleteSelectedLayersItem(selected_layers_item_index)">
                          {{ StoreLangTranslation.data['delete'][StoreLang] }}
                        </b-button>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['43']['parameters']['44']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <input type="text" class="form-control" v-model="selected_layers_item.selected_layer_id[lang.label]">
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['43']['parameters']['45']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <input type="text" class="form-control" v-model="selected_layers_item.selected_layer_name[lang.label]">
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['43']['parameters']['46']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <select class="form-control" v-model="selected_layers_item.parameter_usage_type">
                          <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['43']['parameters']['46'].options" :value="op.value">
                            {{ op.translation[StoreLang] }}
                          </option>
                        </select>
                      </b-col>
                    </b-row>
                    <hr>
                    <template v-if="selected_layers_item.parameter_usage_type === '1'">
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="4">
                          <strong>{{ d_userShopBundleProductWdm['0']['parameters']['43']['parameters']['47']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                        </b-col>
                      </b-row>
                      <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                        <b-col sm="12" lg="1">
                          {{ lang.label }}
                        </b-col>
                        <b-col sm="12" lg="11">
                          <input type="text" class="form-control" v-model="selected_layers_item.selected_parameters[lang.label]">
                        </b-col>
                      </b-row>
                    </template>
                  </b-col>
                </b-row>
                <hr>
              </template>

            </template>

            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleProductData.location_usage_type">
                  <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['49'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>

            <template v-if="d_userShopBundleProductData.location_usage_type === '1'">
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="6">
                </b-col>
                <b-col sm="12" lg="6" style="text-align: right;">
                  <b-button variant="outline-secondary" @click="f_addNewSelectedLocationsItem()">
                    <i class="fa fa-plus-circle"></i> {{ StoreLangTranslation.data['new_location'][StoreLang] }}
                  </b-button>
                </b-col>
              </b-row>
              <template v-if="d_userShopBundleProductData.selected_locations.length > 0">
                <b-row v-for="(selected_locations_item, selected_locations_item_index) in d_userShopBundleProductData.selected_locations" :style="f_calculateItemStyle(selected_locations_item_index)">
                  <b-col sm="12" lg="12">
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="10">
                        <strong>{{ selected_locations_item_index + 1 }} )</strong>
                      </b-col>
                      <b-col sm="12" lg="2">
                        <b-button variant="outline-danger" @click="f_deleteSelectedLocationsItem(selected_locations_item_index)">
                          {{ StoreLangTranslation.data['delete'][StoreLang] }}
                        </b-button>
                      </b-col>
                    </b-row>
                    <hr>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['51']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <input type="text" class="form-control" v-model="selected_locations_item.location_id[lang.label]">
                      </b-col>
                    </b-row>
                    <hr>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['52']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <input type="text" class="form-control" v-model="selected_locations_item.location_name[lang.label]">
                      </b-col>
                    </b-row>
                    <hr>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['53']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <select class="form-control" v-model="selected_locations_item.server_usage_type">
                          <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['53'].options" :value="op.value">
                            {{ op.translation[StoreLang] }}
                          </option>
                        </select>
                      </b-col>
                    </b-row>
                    <hr>

                    <template v-if="selected_locations_item.server_usage_type === '1'">
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="6">
                        </b-col>
                        <b-col sm="12" lg="6" style="text-align: right;">
                          <b-button variant="outline-secondary" @click="f_addNewSelectedServerItem(selected_locations_item_index)">
                            <i class="fa fa-plus-circle"></i> {{ StoreLangTranslation.data['new_server'][StoreLang] }}
                          </b-button>
                        </b-col>
                      </b-row>
                      <template v-if="selected_locations_item.selected_servers.length > 0">
                        <b-row v-for="(selected_servers_item, selected_servers_item_index) in selected_locations_item.selected_servers" :style="f_calculateItemStyle(selected_servers_item_index)">
                          <b-col sm="12" lg="12">
                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="10">
                                <strong>{{ selected_servers_item_index + 1 }} )</strong>
                              </b-col>
                              <b-col sm="12" lg="2">
                                <b-button variant="outline-danger" @click="f_deleteSelectedServersItem(selected_locations_item_index, selected_servers_item_index)">
                                  {{ StoreLangTranslation.data['delete'][StoreLang] }}
                                </b-button>
                              </b-col>
                            </b-row>
                            <hr>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['54']['parameters']['55']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                              </b-col>
                            </b-row>
                            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                              <b-col sm="12" lg="1">
                                {{ lang.label }}
                              </b-col>
                              <b-col sm="12" lg="11">
                                <input type="text" class="form-control" v-model="selected_servers_item.server_id[lang.label]">
                              </b-col>
                            </b-row>
                            <hr>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['54']['parameters']['56']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                              </b-col>
                            </b-row>
                            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                              <b-col sm="12" lg="1">
                                {{ lang.label }}
                              </b-col>
                              <b-col sm="12" lg="11">
                                <input type="text" class="form-control" v-model="selected_servers_item.server_name[lang.label]">
                              </b-col>
                            </b-row>
                            <hr>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['50']['parameters']['54']['parameters']['57']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                              </b-col>
                            </b-row>
                            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                              <b-col sm="12" lg="1">
                                {{ lang.label }}
                              </b-col>
                              <b-col sm="12" lg="11">
                                <input type="text" class="form-control" v-model="selected_servers_item.showed_server_name[lang.label]">
                              </b-col>
                            </b-row>
                            <hr>
                            
                          </b-col>
                        </b-row>
                        <hr>
                      </template>

                    </template>

                  </b-col>
                </b-row>
                <hr>
              </template>

            </template>

            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="12">
                <b-textarea v-model="d_userShopBundleProductData.main_rule_algorithm" rows="5"></b-textarea>
              </b-col>
            </b-row>
            <hr>

            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleProductWdm['0']['parameters']['58']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="12">
                <input type="number" class="form-control" v-model="d_userShopBundleProductData.row_limit_count">
              </b-col>
            </b-row>
            <hr>


          </template>
          <template v-if="['5'].indexOf(d_userShopBundleProductData.product_type) !== -1">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ StoreLangTranslation.data['show_created_bundle'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-button @click="f_showBundle()">
                  {{ StoreLangTranslation.data['show'][StoreLang] }}
                </b-button>
              </b-col>
            </b-row>
            <hr/>
          </template>

        </template>


        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['3']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.can_assign_auth">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['3'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['4']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.pro_auth_id[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.tax_rate_percent[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['6']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="date" class="form-control" v-model="d_userShopBundleProductData.pro_start_date[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['7']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="date" class="form-control" v-model="d_userShopBundleProductData.pro_end_date[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['8']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.pro_group_name[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['9']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.pro_usage_count[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['10']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.pro_count_suffix[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['11']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.pay_delay_max_days[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['12']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.organization_id[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['13']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.organization_name[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['14']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.organization_user_id[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['15']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <input type="text" class="form-control" v-model="d_userShopBundleProductData.organization_username[lang.label]">
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['16']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.preparation_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['16'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['17']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.task_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['17'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['18']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.priority">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['18'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['19']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.pay_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['19'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['20']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.pay_period_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['20'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['21']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.pay_credit_card">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['21'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['22']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.pay_transfer_to_account">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['22'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['23']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">

              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['24']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleProductData.currency_type">
              <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['24'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="6">
          </b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
            <b-button variant="outline-secondary" @click="f_addNewCurrencyAmountItem()">
              <i class="fa fa-plus-circle"></i> {{ StoreLangTranslation.data['new_feature'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
        <template v-if="d_userShopBundleProductData.currency_amount_list.length > 0">
          <b-row v-for="(currency_amount_list, currency_amount_index) in d_userShopBundleProductData.currency_amount_list" :style="f_calculateItemStyle(currency_amount_index)">
            <b-col sm="12" lg="12">
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="10">
                  <strong>{{ currency_amount_index + 1 }} )</strong>
                </b-col>
                <b-col sm="12" lg="2">
                  <b-button variant="outline-danger" @click="f_deleteCurrencyAmountItem(currency_amount_index)">
                    {{ StoreLangTranslation.data['delete'][StoreLang] }}
                  </b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleProductWdm['0']['parameters']['25']['parameters']['26']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <select class="form-control" v-model="currency_amount_list.currency_type">
                    <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['25']['parameters']['26'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleProductWdm['0']['parameters']['25']['parameters']['64']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <select class="form-control" v-model="currency_amount_list.currency_exchange_type">
                    <option v-for="(op, op_index) in d_userShopBundleProductWdm['0']['parameters']['25']['parameters']['64'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <hr>
              <b-row  style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleProductWdm['0']['parameters']['25']['parameters']['27']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                </b-col>
              </b-row>
              <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                <b-col sm="12" lg="1">
                  {{ lang.label }}
                </b-col>
                <b-col sm="12" lg="11">
                  <input type="text" class="form-control" v-model="currency_amount_list.currency_amount[lang.label]">
                </b-col>
              </b-row>
              
            </b-col>
          </b-row>
        </template>

      </b-col>
    </b-row>

    <b-modal v-if="d_showBundleModal" id="d_showBundleModal" v-model="d_showBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['show'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_modalLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>
        

        <template v-if="d_datasetViewLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTable" :key="'dataset_view'" :p_tableDetails="d_datasetWTable"></w-table2>
        </template>

        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.bundle_name[StoreLang] }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleProductData.wanalyzer_project_id[StoreLang] }}
          </b-col>
        </b-row>
        <div v-if="d_userShopBundleData.which_one_best_describes_your_reason_for_sharing_dataset">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['51']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_userShopBundleData.dataset_usage_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['51'].options[d_userShopBundleData.which_one_best_describes_your_reason_for_sharing_dataset].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <!-- {{ d_userShopBundleData.about_dataset[StoreLang] }} -->
            <div v-html="d_userShopBundleData.about_dataset[StoreLang]"></div>
          </b-col>
        </b-row>
        <div v-if="d_userShopBundleData.demo_dataset">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_userShopBundleData.demo_dataset }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['35'].options[d_userShopBundleData.demo_dataset].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <div v-if="d_userShopBundleData.dataset_usage_type">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_userShopBundleData.dataset_usage_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['40'].options[d_userShopBundleData.dataset_usage_type].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <div v-if="d_userShopBundleData.dataset_usage_type == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.visiting_research_institution_request_text[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <div v-if="d_userShopBundleData.licence_type">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_userShopBundleData.licence_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['46'].options[d_userShopBundleData.licence_type].translation[StoreLang] }}
            </b-col>
          </b-row>
          <hr>
        </div>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.row_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.column_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.various_variables[StoreLang] }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.methodologies_and_analyses_to_be_excluded[StoreLang] }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.data_collection_center_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.data_collection_centers[StoreLang] }}
          </b-col>
        </b-row>
        <div v-if="d_userShopBundleData.special_acknowledgement_request_status == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.special_acknowledgement_text[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <!-- <div v-if="d_userShopBundleData.dataset_publication_status_in_an_article == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.journal_name }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.article_title }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['50']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.link }}
            </b-col>
          </b-row>
        </div> -->
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.dataset_creator_note }}
          </b-col>
        </b-row>
        <div v-if="d_userShopBundleData.communication_with_the_user_requesting_the_dataset == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.dataset_creator_phone }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.dataset_creator_mail }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_userShopBundleData.dataset_creator_note_to_requester[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.ethics_committee_approval_institution[StoreLang] }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.ethics_committee_date }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_userShopBundleData.ethics_committee_protocol_number }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button @click="f_changeToModal('edit')" variant="warning">{{ StoreLangTranslation.data['edit'][StoreLang] }}</b-button>
            <b-button @click="d_showBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <b-modal v-if="d_editBundleModal" id="d_editBundleModal" v-model="d_editBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['edit'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_modalLoading || d_saveLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>
              {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
            </strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-file
              v-model="d_excelFile"
              accept=".xlsx, .xls"
              ref="excelFileInput"
              @change="f_handleFileUpload"
              :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
              :placeholder="StoreLangTranslation.data['select_excel_file'][StoreLang]"
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button v-if="d_userShopBundleClientID" @click="f_changeToModal('show')" variant="warning">{{ StoreLangTranslation.data['show'][StoreLang] }}</b-button>
            <b-button @click="d_editBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
            <b-button @click="f_saveBundle()" :disabled="d_userShopBundleClientID || d_excelFileBase64 ? false : true" variant="success" style="float: right; margin-right: 5px">{{ StoreLangTranslation.data['save'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    
    <b-modal
      v-if="d_excelCorrection.show"
      id="d_excelCorrection_show"
      v-model="d_excelCorrection.show"
      hide-footer
      title="Excel Edit"
      centered
      header-bg-variant="info"
      header-text-variant="dark"
      size="xl"
      class="my-big-modal"
    >

      <!-- HEADER -->
      <b-row class="m-1">
        <b-col cols="6">
          <h3>{{ StoreLangTranslation.data['excel_upload_settings'][StoreLang] }}</h3>
        </b-col>
        <b-col cols="6" class="text-right">
          <b-spinner v-if="d_saveLoading" variant="primary" />
          <b-button
            v-else
            variant="outline-success"
            class="mr-1"
            @click="f_saveBundle('modal')"
          >
            {{ StoreLangTranslation.data['save'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>

      <b-row class="m-1" v-if="d_excelCorrection.correction_column_list.length > 0">
        <b-col cols="12">
          <span style="color: red">1. {{ StoreLangTranslation.data['excel_warning_1'][StoreLang] }}</span>
        </b-col>
        <b-col cols="12">
          <span style="color: red">2. {{ StoreLangTranslation.data['excel_warning_2'][StoreLang] }}</span>
        </b-col>
      </b-row>

      <b-row class="m-1" v-if="d_excelCorrection.correction_column_list.length">
        <b-col cols="12">
          <strong>{{ StoreLangTranslation.data['correction_suggestions'][StoreLang] }}</strong>
        </b-col>
      </b-row>

      <!-- TABLE -->
      <b-table-simple
        v-if="d_excelCorrection.correction_column_list.length"
        small
        caption-top
        class="correction-table-fixed-header"
      >
        <b-thead head-variant="dark">
          <b-tr>
            <b-th style="width:20px">#</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['column'][StoreLang] }}</b-th>
            <b-th style="width:150px">{{ StoreLangTranslation.data['column_type'][StoreLang] }}</b-th>
            <b-th style="width:80px">{{ StoreLangTranslation.data['number_of_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['value_to_write_to_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['numeric_values'][StoreLang] }}</b-th>
            <b-th style="width:300px">{{ StoreLangTranslation.data['option_to_replace'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['column_incompatible'][StoreLang] }}</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr
            v-for="(col, col_ind) in d_excelCorrection.correction_column_list"
            :key="col_ind"
            :class="{ 'even-row': col_ind % 2 === 0 }"
          >
            <b-td style="width:20px">{{ col_ind + 1 }}</b-td>

            <b-td style="width:120px">
              <!-- <strong class="text-truncate d-block">{{ col.label }}</strong> -->
              <strong>{{ col.label }}</strong>
            </b-td>

            <b-td :style="{ width: '150px', backgroundColor: d_paramTypeColors[col.param_type]}">
              <b-form-select v-model="col.param_type" size="sm" :style="{backgroundColor: d_paramTypeColors[col.param_type]}">
                <option value="text" style="background-color: white;">{{ StoreLangTranslation.data['type_text'][StoreLang] }}</option>
                <option value="select" style="background-color: white;">{{ StoreLangTranslation.data['type_select'][StoreLang] }}</option>
                <option value="float" style="background-color: white;">{{ StoreLangTranslation.data['type_float'][StoreLang] }}</option>
                <option value="integer" style="background-color: white;">{{ StoreLangTranslation.data['type_integer'][StoreLang] }}</option>
                <option value="datetime" style="background-color: white;">{{ StoreLangTranslation.data['type_datetime'][StoreLang] }}</option>
              </b-form-select>
            </b-td>

            <b-td style="width:80px" class="text-center">{{ col.null_count }}</b-td>

            <b-td style="width:120px">
              <b-form-input v-model="col.value_for_null" size="sm" />
            </b-td>

            <b-td style="width:200px" class="small">
              <template v-if="col.param_type === 'integer' || col.param_type === 'float'">
                <div v-if="col.mean_value"><strong>Ortalama:</strong> {{ (+col.mean_value).toFixed(2) }}</div>
                <div v-if="col.minimum_value || col.maximum_value"><strong>Min / Max:</strong> {{ col.minimum_value || '-' }} / {{ col.maximum_value || '-' }}</div>
                <div v-if="col.standart_deviation"><strong>Standart Sapma:</strong> {{ (+col.standart_deviation).toFixed(2) }}</div>
                <div v-if="col.outliers_interquartile_range">
                  <strong>Alt / Üst (IQR):</strong>
                  {{ (+col.outliers_interquartile_range.lower_bound).toFixed(2) }} /
                  {{ (+col.outliers_interquartile_range.upper_bound).toFixed(2) }}
                </div>
              </template>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:300px">
              <div v-if="col.param_type === 'select'" class="option-box">
                <div v-for="(opt, i) in col.options" :key="i" class="mb-1">
                  <small><strong>{{ opt.label }}</strong> / {{ opt.count }}</small>
                  <b-form-input v-model="opt.correct_label" size="sm" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:200px">
              <div class="error-box" v-if="col.incompatible_with_column_type">
                <div v-for="(v, k) in col.incompatible_with_column_type" :key="k">
                  <small>{{ k }} →</small>
                  <b-form-input v-model="v.val" size="sm" class="d-inline-block w-50" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>













  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
import { mapGetters } from 'vuex';
export default {
  name: 'ShopBundleProductRecord',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    WTable2,
  },
  props: {
    p_userShopClientID: {
      type: String,
      required: true
    },
    p_userShopBundleClientID: {
      type: String,
      required: true
    },
    p_userShopBundleProductClientID: {
      type: String,
      required: true
    },
    f_userShopBundleProductList: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      d_loading: false,
      d_saveLoading: false,
      d_user: '',
      d_userShopBundleProductId: '',
      d_userShopBundleProductLayerId: '',
      d_frontendClientID: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_userShopBundleProductClientID: '',
      d_frontendList: [],
      d_userShopBundleProductWdm: '',
      d_usrShpBundWdm: '',
      d_userShopBundleData: {
        'status': '',
        'bundle_name': {},
        'dataset_creator_note': '',
        'communication_with_the_user_requesting_the_dataset': '',
        'dataset_creator_phone': '',
        'dataset_creator_mail': '',
        'dataset_creator_note_to_requester': '',
        'reason_for_cancellation': '',
        'reason_for_cancellation_note': '',
        'special_acknowledgement_request_status': '',
        'special_acknowledgement_text': '',
        'demo_dataset': '',
        'row_count': '',
        'column_count': '',
        'various_variables': '',
        'about_dataset': '',
        'dataset_usage_type': '',
        'methodologies_and_analyses_to_be_excluded': '',
        'data_collection_center_count': '',
        'data_collection_centers': '',
        'licence_type': '',
        'dataset_publication_status_in_an_article': '',
        'journal_name': '',
        'article_title': '',
        'link': '',
        'which_one_best_describes_your_reason_for_sharing_dataset': '',
        'visiting_research_institution_request_text': '',
        'ethics_committee_approval_institution': '',
        'ethics_committee_date': '',
        'ethics_committee_protocol_number': '',
      },
      d_userShopBundleProductData: {
        'status': '0',
        'product_type': '0',
        'getting_analysis_output_with_column_inputs_id_type': '0',
        'wanalyzer_project_id': {},
        'wanalyzer_stats_id': {},
        'wanalyzer_machinelearning_id': {},
        'pro_name': {},
        'can_assign_auth': '0',
        'pro_auth_id': {},
        'pro_info': {},
        'tax_rate_percent': {},
        'pro_end_date': {},
        'pro_start_date': {},
        'pro_group_name': {},
        'pro_usage_count': {},
        'pro_count_suffix': {},
        'pay_delay_max_days': {},
        'organization_id': {},
        'organization_name': {},
        'organization_user_id': {},
        'organization_username': {},
        'preparation_type': '1',
        'task_type': '',
        'priority': '',
        'pay_type': '',
        'pay_period_type': '',
        'pay_credit_card': '',
        'pay_transfer_to_account': '',
        'pro_usage_count_type': '',
        'currency_type': '',
        'currency_amount_list': [],
        'show_in_bundle_product_list': '1',
        'expiration_time_type': '2',
        'in_store_visibility': '1',
        'expiration_time_value': {},
        'expiration_time_value_by_text': {},
        'price_includes_taxes': '0',
        'organization_token': {},
        'product_code': {},
        'layer_tree': {},
        'layer_usage_type': '',
        'main_rule_algorithm': '',
        'row_limit_count': '',
        'selected_layers': [],
      },
      ClsUser: ClsUser,
      d_showBundleModal: false,
      d_editBundleModal: false,
      d_modalLoading: false,
      d_datasetViewLoading: false,
      d_saveLoading: false,
      d_datasetWTable: '',
      d_excelFile: null,
      d_excelFileBase64: '',
      d_excelFileName: '',
      d_excelCorrection: {
        'correction_column_list': [],
        'show': false,
        'column_type': 'clear',
        'column_design': 'create_new_column_types',
        'dataset_type': 'clear',
      },
      d_paramTypeColors: {
        'text': '#f7f3ff',
        'select': '#ffe5e5',
        'float': '#e5f0ff',
        'integer': '#e8ffe5',
        'datetime': '#fff3e0',
      },
    };
  },
  created: function () {
    this.d_loading = true;
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shp_bund_pro').then(resp_wdm_data => { this.d_userShopBundleProductWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.p_userShopClientID;
    // if (this.$route.query.user_shop_client_id) {
    //   this.d_userShopClientID = this.$route.query.user_shop_client_id;
    // }

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      this.d_userShopBundleClientID = this.p_userShopBundleClientID;
      // if (this.$route.query.user_shop_bundle_client_id) {
      //   this.d_userShopBundleClientID = this.$route.query.user_shop_bundle_client_id;
      // }
      this.d_userShopBundleProductClientID = this.p_userShopBundleProductClientID;
      // if (this.$route.query.user_shop_bundle_product_client_id) {
      //   this.d_userShopBundleProductClientID = this.$route.query.user_shop_bundle_product_client_id;
      // }
      if (this.d_userShopBundleProductClientID) {
        this.f_userShopBundleProductGet();
      }
      if (!this.d_userShopClientID) {
        alert(this.StoreLangTranslation.data['shop_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      if (!this.d_userShopBundleClientID) {
        alert(this.StoreLangTranslation.data['bundle_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      if (!this.d_userShopBundleProductClientID) {
        this.f_langEligibleParameterProcess();
        this.d_loading = false;
      }
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {

    f_showBundle: function () {
      this.d_showBundleModal = true;
      this.f_wanalyzerProjectDatasetGet();
    },
    f_wanalyzerProjectDatasetGet: function () {
      this.d_datasetViewLoading = true;
      let query = 'project_id=' + this.d_userShopBundleProductData['wanalyzer_project_id'][this.StoreLang];
      // hangi tipte yetki ataması yapılacaksa kullanıcıya o eklenecek
      query += '&auth_client_id=' + this.d_user + "_" + this.d_userShopBundleProductData['wanalyzer_project_id'][this.StoreLang] + "_dataset_filter";
      let data = {
        'pagination': '',
        'filter_rule': {},
        'wai_columns': 'no',
        'bundle_client_id': this.d_userShopBundleClientID,
      };
      this.d_datasetWTable = '';
      ServiceFunctions.wanalyzer_project_dataset_get(query, data)
        .then(resp => {
          this.d_datasetViewLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_datasetWTable = resp.data.wtable;
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_saveBundle: function (call_from) {
      // this.d_excelCorrection.correction_column_list = []
      this.d_saveLoading = true;
      // let query = 'user_client_id=' + this.d_user.username;
      let query = 'user_client_id=' + this.d_userShopBundleData['package_creator_user'];
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      if (this.d_userShopBundleClientID) {
        query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      }
      let data = {
        // 'bundle_data': this.d_userShopBundleData,
        // 'product_data': this.d_userShopBundleProductData,
        'correction_column_list': this.d_excelCorrection.correction_column_list,
      };
      if (this.d_excelFileBase64) {
        data['excel_file'] = this.d_excelFileBase64;
      }
      // console.log(data)
      ServiceFunctions.user_created_bundle_record(query, data)
        .then(resp => {
          this.d_saveLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            // this.d_userShopBundleData = resp.data['bundle_data'];
            // this.d_userShopBundleProductData = resp.data['product_data'];
            // // this.f_langEligibleParameterProcess();
            // this.f_userCreatedBundleList();
            // // this.$forceUpdate();
            // this.f_changeToModal('show');
            // if (this.d_excelCorrection.correction_column_list.length === 0) {
              try {
                this.d_excelCorrection.correction_column_list = resp.data.excel_response.result.correction_column_list;
              } catch (err) {}
            // }
            if (call_from === 'modal' || this.d_excelCorrection.correction_column_list.length === 0) {
              this.d_excelCorrection.show = false;
            } else {
              this.d_excelCorrection.show = true;
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_changeToModal: function (new_modal) {
      if (new_modal == 'show') {
        this.d_editBundleModal = false;
        this.d_showBundleModal = true;
        if (this.d_userShopBundleProductData['wanalyzer_project_id'] && this.d_userShopBundleProductData['wanalyzer_project_id'][this.StoreLang] && !this.d_datasetWTable) {
          this.f_wanalyzerProjectDatasetGet();
        }
      } else if (new_modal == 'edit') {
        this.d_excelCorrection.correction_column_list = []
        this.d_showBundleModal = false;
        this.d_editBundleModal = true;
      }
    },
    f_handleFileUpload: function (event) {
      const file = event.target.files[0];
      if (file) {
        if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
          const max_size_bytes = 50 * 1024 * 1024;
          if (file.size > max_size_bytes) {
            alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang] + ' (max 50mb)');
            this.d_excelFile = null;
            this.d_excelFileBase64 = '';
            this.d_excelFileName = '';
            this.$refs.excelFileInput.reset();
          } else {
            this.d_excelFileName = file.name;

            var vm = this;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
              vm.d_excelFileBase64 = reader.result;
              vm.$forceUpdate();
            }, false);
            reader.readAsDataURL(file);
          }

        } else {
          this.d_excelFile = null;
          this.d_excelFileBase64 = '';
          this.d_excelFileName = '';
          this.$refs.excelFileInput.reset();
          this.$bvToast.toast(this.StoreLangTranslation.data['upload_only_excel_file'][this.StoreLang], {
            title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
            variant: 'danger',
            solid: true,
          });
        }

      } else {
        this.d_excelFileName = '';
      }
    },
    f_deleteSelectedLayersItem: function (item_index) {
      this.d_userShopBundleProductData.selected_layers.splice(item_index, 1);
    },
    f_deleteSelectedLocationsItem: function (item_index) {
      this.d_userShopBundleProductData.selected_locations.splice(item_index, 1);
    },
    f_deleteSelectedServersItem: function (item_index, sub_item_index) {
      this.d_userShopBundleProductData.selected_locations[item_index].selected_servers.splice(sub_item_index, 1);
    },
    f_addNewSelectedLayersItem: function () {
      let lang_eligible_variables = ['selected_layer_id', 'selected_layer_name', 'selected_parameters'];
      let new_item = {
          'selected_layer_id': {},
          'selected_layer_name': {},
          'parameter_usage_type': '',
          'selected_parameters': {},
      };
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          new_item[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
        }
      }
      this.d_userShopBundleProductData.selected_layers.push(new_item);
    },

    f_addNewSelectedLocationsItem: function () {
      let lang_eligible_variables = ['location_id', 'location_name'];
      let new_item = {
          'location_id': {},
          'location_name': {},
          'server_usage_type': '',
          'selected_servers': [],
      };
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          new_item[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
        }
      }
      this.d_userShopBundleProductData.selected_locations.push(new_item);
    },

    f_addNewSelectedServerItem: function (selected_locations_item_index) {
      let lang_eligible_variables = ['server_id', 'server_name', 'showed_server_name'];
      let new_item = {
          'server_id': {},
          'server_name': {},
          'showed_server_name': {},
      };
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          new_item[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
        }
      }
      this.d_userShopBundleProductData.selected_locations[selected_locations_item_index].selected_servers.push(new_item);
    },

    f_deleteCurrencyAmountItem: function (currency_amount_index) {
      this.d_userShopBundleProductData.currency_amount_list.splice(currency_amount_index, 1);
    },
    f_addNewCurrencyAmountItem: function () {
      let lang_eligible_variables = ['currency_amount'];
      let new_item = { 'currency_type': '', 'currency_exchange_type':'','currency_amount': {} };
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          new_item[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
        }
      }
      this.d_userShopBundleProductData.currency_amount_list.push(new_item);
    },
    f_calculateItemStyle: function (item_index) {
      let style = 'margin: 3px;';
      if (item_index % 2 === 0) {
        style += 'background-color: #99e4e8';
      } else {
        // style += 'background-color: #99e4e8';
        style += 'background-color: white;';
      }
      return style;
    },
    f_goToShopList: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_list'), query: {} });
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['pro_name', 'pro_auth_id', 'organization_id', 'organization_name', 'organization_user_id', 'organization_username', 'expiration_time_value', 'expiration_time_value_by_text', 'organization_token', 'wanalyzer_project_id', 'wanalyzer_stats_id', 'wanalyzer_machinelearning_id', 'product_code', 'layer_tree', 'pro_info'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_userShopBundleProductData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_userShopBundleProductData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_userShopBundleProductRecord: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      if (this.d_userShopClientID) {
        query += '&user_shop_client_id=' + this.d_userShopClientID;
      }
      if (this.d_userShopBundleClientID) {
        query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      }
      if (this.d_userShopBundleProductClientID) {
        query += '&user_shop_bundle_product_client_id=' + this.d_userShopBundleProductClientID;
      }
      for (let i in this.d_userShopBundleProductData) {
        data[i] = this.d_userShopBundleProductData[i];
      }
      this.d_saveLoading = true;
      if (this.d_userShopBundleProductClientID) {
        console.log("data", data);
        ServiceFunctions.user_shop_bundle_product_edit(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      } else {
        console.log("data",data);
        ServiceFunctions.user_shop_bundle_product_new(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.f_userShopBundleProductList();
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_userShopBundleGet: function () {
      let query = 'user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      query += '&data_type=value_mode';
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shop_bundle_get(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userShopBundleData = resp.data.data;
              // this.f_langEligibleParameterProcess();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userShopBundleProductGet: function () {
      this.d_loading = true;
      let query = 'user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      query += '&data_type=value_mode';
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_shop_bundle_product_client_id=' + this.d_userShopBundleProductClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shop_bundle_product_get(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userShopBundleProductData = resp.data.data;
              this.d_userShopBundleProductId = resp.data.id;
              this.d_userShopBundleProductLayerId = resp.data.layer_id;
              this.f_langEligibleParameterProcess();
              this.f_userShopBundleGet();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    d_showBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
    },

    d_editBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
    },
  }
};

</script>

<style>
#d_excelCorrection_show .modal-dialog {
  max-width: 95vw !important;
  width: 95vw !important;
}
#d_excelCorrection_show .modal-content {
  height: 90vh !important;
}

/* Tabloya table-layout: fixed atar ve başlık hücrelerinin genişliklerini korumasını sağlar. */
.correction-table-fixed-header {
    table-layout: fixed;
    width: 100%; 
}

/* TH'lerin sabitlenmesi için zorunlu CSS */
.correction-table-fixed-header thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* Başlığın kaybolmaması için arka plan rengini zorlayın */
    background-color: #343a40; 
}

/* Tbody'yi blok seviyesinde gösterip kaydırma ekler. */
.correction-table-fixed-header tbody {
    display: block;
    overflow-y: auto;
    /* max-height 55vh'den 65vh'ye (veya daha yüksek bir değere) çıkarıldı. 
       Bu, modalin altındaki beyaz boşluğu doldurmak için daha fazla alan kullanır. */
    max-height: 65vh; 
}

/* Tbody display: block olduğunda, içerideki TR'lerin genişliğini başlık genişliğine eşitler */
.correction-table-fixed-header tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
</style>